import { render, staticRenderFns } from "./CouponListScreen.vue?vue&type=template&id=251661f8&"
import script from "./CouponListScreen.vue?vue&type=script&lang=ts&"
export * from "./CouponListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports